var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.clicked}},[(_vm.isLoading)?_c('span',{staticStyle:{"margin-right":"10px"}},[_c('FontAwesomeIcon',{attrs:{"icon":['fa', 'spinner'],"pulse":""}})],1):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }